import React from 'react';

import NewCoursePage from './NewCoursePage';

const NewCustomer = props => (
  <NewCoursePage {...props} videoLink="dxf1Vja2JR0" header={"Accessible Customer Service"}>
    <p className="new-course__body__content__para">
      The foundation of great accessible customer service and communication involves being a good listener and treating
      people with respect. There are verbal and non-verbal methods of communication that are useful for interacting with
      people with different disabilities.
    </p>
    <hr />
    <h4>3 Tools for Accessible Service</h4>
    <ol className="new-course__body__content__olist">
      <li>
        Person First
        <ul className="new-course__body__content__olist--ulist">
          <li>
            The person first framework emphasizes the person, not the disability; in the way you see someone and in the
            language you use.
          </li>
          <li>
            People with disabilities are individual people with their own needs, interests and abilities and they are
            not defined by their disability. It is just one aspect of their life.
          </li>
          <li>
            The ‘person first’ language we use reinforces this. For example, instead of ‘disabled person’, use person
            with a disability. Instead of ‘wheelchair user’, use ‘person who uses a wheelchair’.
          </li>
        </ul>
      </li>
      <li>
        Ask First
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Listen carefully and ask what works best for your customer if in doubt. If unsure, ask if they want help and
            how you can best provide assistance.
          </li>
          <li>
            Many drivers insist on offering help with a positive intention but this can lead to a dangerous situation.
            You can not take control without asking. For example, do not assume a customer wants you to push their
            wheelchair or fasten their seat belt, ask first. If a passenger says ‘no thank you’, respect that.
          </li>
          <li>
            The general rule is you should not touch or move someone’s assistive device unless they have given you
            permission to do so.
          </li>
        </ul>
      </li>
      <li>
        Be Considerate
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Most people with disabilities are not looking for pity or empathy. If you offer help and it is turned down,
            do not continue to insist on helping.
          </li>
          <li>
            Avoid disrespectful terms like suffers, unfortunately, abnormal, special and handicapped. It is best not to
            ask about someone’s disabilities as it is personal.
          </li>
          <li>
            Calling someone with a disability “inspiring” or “brave” just for doing regular activities like walking or
            shopping can be patronising.
          </li>
        </ul>
      </li>
    </ol>
    <br />
    <br />
  </NewCoursePage>
);

export default NewCustomer;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewCustomer.js